export enum BadgeType {
  Dot = 'dot',
  Badge = 'badge',
}

interface BadgeState {
  shouldShow: boolean;
  type?: BadgeType;
  label?: string;
  description?: string;
  onClick?: () => void;
}

export const MenuItemBadgeRegistry = {
  badges: new Map<string, BadgeState>(),

  register(key: string, state: BadgeState) {
    this.badges.set(key, state);
  },

  getBadge(key: string): BadgeState | undefined {
    return this.badges.get(key);
  },
};
